<template>
  <div class="mt-4 ml-3"> 
    <component :is="componentSwitcher" v-bind:getSelectedItemId="getSelectedItemId"/>
  </div>
</template>

<script>
import ShopVoucherServiceGroupPrices from "@/components/ShopVoucherServicePersonGroupPrices";
import ShopVoucherServiceFixedPrice from "@/components/ShopVoucherServiceFixedPrice";
import ShopVoucherServiceVariablePrice from "@/components/ShopVoucherServiceVariablePrice";
import ShopVoucherServicePriceList from "@/components/ShopVoucherServicePriceList";
import ShopTicketService from "@/components/ShopTicketService";

export default {
  name: "ShopVoucherServiceSelection",
  props: ["getSelectedItemId"],
  components: {
    ShopVoucherServiceGroupPrices,
    ShopVoucherServiceFixedPrice,
    ShopVoucherServiceVariablePrice,
    ShopVoucherServicePriceList,
    ShopTicketService
  },
  methods: {
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    componentSwitcher() {
      if (this.getSelectedItem.type == "voucher") {
        //console.log("Type was Voucher");
        // Voucher may have different 'voucherType'
        if (this.getSelectedItem.voucherType == "personGroupPrices") {
         // console.log("subType personGroupPrices: " + this.getSelectedItem.personGroups.length);

          return "ShopVoucherServiceGroupPrices";
        } else if (this.getSelectedItem.voucherType == "fixedPrice") {
         // console.log("Type fixedPrice: " + this.getSelectedItem.fixedPrice);

          return "ShopVoucherServiceFixedPrice";
        } else if (this.getSelectedItem.voucherType == "variablePrice") {
         // console.log("Type variablePrice: " + this.getSelectedItem.minimumPrice +" " + this.getSelectedItem.maximumPrice);

          return "ShopVoucherServiceVariablePrice";
        } else if (this.getSelectedItem.voucherType == "priceList") {
         // console.log("Type priceList: " + this.getSelectedItem.prices.length);

          return "ShopVoucherServicePriceList";
        } else {
          // TODO
        }
      } else if (this.getSelectedItem.type == "ticket") {
        //console.log("Type was Ticket");
        return "ShopTicketService";
      }
      return [];
    },
    getSelectedItem: function() {
      return this.getCachedItem();
    }
  },
  beforeMount() {}
};
</script>

